import React from 'react';
import { shape, string, arrayOf } from 'prop-types';
import classnames from 'classnames';
import colornames from '../../lib/colornames';
import IconFactory from '../icons/factory-builder';
import StyledLabel from '../styled-label';
import { generateKeyToComponent } from '../../utils/validators';

/**
 * Function to determine if has to clean row spacing, each 3 items
 * @param itemIndex
 * @returns {boolean}
 */
const shouldResetRow = itemIndex => itemIndex > 0 && itemIndex % 3 === 0;

const namespace = 'ui-pdp-highlighted-sale-specs';
const HighLightedSaleSpecs = ({ header, sections = null }) => (
  <div className={classnames(namespace)}>
    <StyledLabel as="h2" className={`${namespace}__header`} {...header} />
    {sections?.map(section => (
      <div key={generateKeyToComponent(section)} className={`${namespace}__specs-list`}>
        {section.attributes.map((spec, specIndex) => (
          <>
            {shouldResetRow(specIndex) && <div className={`${namespace}__spec-row-cleaner`} />}
            <div key={spec.label.text} className={`${namespace}__spec`}>
              <div aria-hidden="true" className={`${namespace}__icon`}>
                {IconFactory(spec.icon.id, classnames(colornames(spec.icon.color)))}
              </div>
              <StyledLabel {...spec.label} />
            </div>
          </>
        ))}
      </div>
    ))}
  </div>
);

HighLightedSaleSpecs.propTypes = {
  header: shape({
    text: string,
    color: string,
    font_size: string,
    font_family: string,
  }).isRequired,
  sections: arrayOf(
    shape({
      attributes: arrayOf(
        shape({
          icon: shape({
            id: string.isRequired,
            color: string,
          }),
        }),
      ),
    }),
  ),
};

export default React.memo(HighLightedSaleSpecs);
